<template>
  <div class="content ledger-list">
    <div class="form-content">
      <a-row :gutter="16">
        <a-col :span="6">
          <SelectAccountSet
            :placeholder="$t(`账簿`)"
            :code="formData.accountSetUnionCode"
            @change="changeAccountSet"
          />
        </a-col>
        <a-col :span="6">
          <a-input :disabled="true" :value="formData.businessUnitName" />
        </a-col>
        <a-col :span="6">
          <a-input
            readOnly
            :value="accountName"
            @click="showAccountModal"
            :placeholder="$t('科目名称')"
          >
            <a-icon
              v-if="accountName"
              slot="suffix"
              type="close-circle"
              @click.stop="clearAccount"
              style="cursor: pointer; color: #ccc"
            />
          </a-input>
        </a-col>
        <a-col :span="6">
          <a-select
            style="width: 100%"
            v-model="accountingPeriodStart"
            :placeholder="$t(`开始期间`)"
          >
            <a-select-option
              v-for="(item, index) in periodListStart"
              :key="index"
              :value="item.accounting_period_code"
            >
              {{ item.accounting_period_name }}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>
      <a-row :gutter="16" class="mt10">
        <a-col :span="6">
          <a-select style="width: 100%" v-model="accountingPeriodEnd" :placeholder="$t(`结束期间`)">
            <a-select-option
              v-for="(item, index) in periodListEnd"
              :key="index"
              :value="item.accounting_period_code"
            >
              {{ item.accounting_period_name }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6">
          <a-button @click="searchHandle(1)" type="primary">
            <i class="iconfont" style="margin-right: 5px">&#xe647;</i>
            {{ $t(`查询`) }}
          </a-button>
          <a-button @click="reset">
            <a-icon type="redo" />
            {{ $t(`重置`) }}
          </a-button>
        </a-col>
      </a-row>
    </div>
    <CommonTable
      v-show="showTable"
      ref="CommonTableRef"
      :columns.sync="columns"
      :loading="loading"
      :dataSource="tableData"
      :scroll="{ y: scrollHeight }"
      :total="total"
      rowKey="id"
      @search="getList"
    >
      <template v-slot:accountCode="{ text, record }">
        <a @click="goToAccountJournalList(record)">{{ text }}</a>
      </template>
      <template v-slot:voucherNo="{ text, record }">
        <span class="text-link" @click="goJump(record)">
          {{ $store.getters.journalVoucherTypeMapping[record.voucherType] }} {{ text }}
        </span>
      </template>
    </CommonTable>
    <a-modal
      v-model="visible"
      :title="$t('科目列表')"
      width="1200px"
      @cancel="visible = false"
      @ok="onOk"
    >
      <AccountList ref="AccountListRef" :showSelect="true" @select="onSelect" />
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import http from '@/service/axios'
import api from '@/service/api'
import CommonTable from '@/component/commonTable'
import AccountList from '../baseInfo/accountList'
import SelectAccountSet from '@/component/selectAccountSet.vue'
import { convertKeysToCamelCase, jumpSoucePage } from '@/common'
export default {
  name: 'accountJournalList',
  components: { CommonTable, AccountList, SelectAccountSet },
  data() {
    return {
      docType: 'Ledger',
      showTable: false,
      formData: {
        accountSetUnionCode: undefined,
        accountCodeList: [],
      },
      tableData: [],
      selectedRowKeys: [],
      selectedRows: [],
      total: 0,
      loading: false,

      columns: [],
      periodList: [],

      accountingPeriodStart: undefined,
      accountingPeriodEnd: undefined,
      accountName: undefined,
      visible: false,
    }
  },
  mounted() {
    this.setColumns()
    this.getPeriodList()
  },
  // activated() {
  //   this.searchHandle()
  // },
  computed: {
    scrollHeight() {
      return window.innerHeight - 350
    },
    periodListStart() {
      let list = this.periodList
      if (this.accountingPeriodEnd) {
        list = list.filter(
          (item) =>
            moment(item.accounting_period_code).isBefore(this.accountingPeriodEnd) ||
            item.accounting_period_code === this.accountingPeriodEnd
        )
      }
      return list
    },
    periodListEnd() {
      let list = this.periodList
      if (this.accountingPeriodStart) {
        list = list.filter(
          (item) =>
            moment(item.accounting_period_code).isAfter(this.accountingPeriodStart) ||
            item.accounting_period_code === this.accountingPeriodStart
        )
      }
      return list
    },
  },
  methods: {
    reset() {
      Object.assign(this.$data, this.$options.data())
      this.setColumns()
    },
    searchHandle(pageNo) {
      this.$refs.CommonTableRef.queryList(pageNo)
    },
    setColumns() {
      this.columns = [
        {
          title: this.$t('科目编码'),
          dataIndex: 'accountCode',
          scopedSlots: { customRender: 'accountCode' },
          width: 120,
        },
        {
          title: this.$t('科目名称'),
          dataIndex: 'accountFullName',
        },
        {
          title: this.$t('会计期间'),
          dataIndex: 'accountingPeriodName',
        },
        // {
        //   title: this.$t('摘要'),
        //   dataIndex: 'summary',
        // },
        {
          title: this.$t('期初余额方向'),
          dataIndex: 'beginBalanceDirection',
          width: 120,
          customRender: (text) => this.$store.getters.balanceDirectionMapping[text],
        },
        {
          title: this.$t('期初余额'),
          dataIndex: 'beginBalance',
          customRender: (text, record) => this.$currencySymbol(text, record.currency),
          width: 150,
        },
        {
          title: this.$t('借方金额'),
          dataIndex: 'debitAmount',
          customRender: (text, record) => this.$currencySymbol(text, record.currency),
          width: 120,
        },
        {
          title: this.$t('贷方金额'),
          dataIndex: 'creditAmount',
          customRender: (text, record) => this.$currencySymbol(text, record.currency),
          width: 120,
        },
        {
          title: this.$t('期末余额方向'),
          dataIndex: 'balanceDirection',
          width: 120,
          customRender: (text) => this.$store.getters.balanceDirectionMapping[text],
        },
        {
          title: this.$t('期末余额'),
          dataIndex: 'balance',
          customRender: (text, record) => this.$currencySymbol(text, record.currency),
          width: 150,
        },
      ]
    },
    changeAccountSet(value) {
      let arr = value.unionCode?.split('-')
      this.formData.accountSetUnionCode = value.unionCode
      this.formData.businessUnitCode = value.business_unit_code
      this.formData.businessUnitName = value.business_unit_name
      if (arr.length > 1) {
        this.formData.accountSetCode = arr[0]
      } else {
        this.formData.accountSetCode = undefined
      }
      this.searchHandle(1)
    },
    getPeriodList() {
      http({
        url: api.queryAccountingCalendarDetailPage,
        data: {},
        success: (res) => {
          this.periodList = res.result.list
        },
      })
    },
    generatePeriods(startDate, endDate) {
      const periods = []
      let currentDate = new Date(startDate)
      const endDateObj = new Date(endDate)
      while (currentDate <= endDateObj) {
        periods.push(currentDate.toISOString().slice(0, 7)) // 格式化为 YYYY-MM
        currentDate.setMonth(currentDate.getMonth() + 1) // 增加一个月
      }
      return periods
    },
    async getList(params) {
      this.showTable = true
      this.loading = true
      const data = {
        ...this.formData,
        ...params,
      }
      if (this.accountingPeriodStart && this.accountingPeriodEnd) {
        data.accountingPeriodList = this.generatePeriods(
          this.accountingPeriodStart,
          this.accountingPeriodEnd
        )
      }
      await http({
        url: api.getAccountJournalPeriodList,
        data,
        success: (res) => {
          let result = convertKeysToCamelCase(res.result)
          this.tableData = result.list.map((item) => {
            item.dimensionListName =
              item.accountingDimensionName + ': ' + item.accountingDimensionValueName
            item.accountingPeriodName =
              item.accountingPeriod.replace('-', this.$t('年')) + this.$t('期')
            return item
          })
          this.total = res.result.total
        },
      })
      this.loading = false
    },
    goJump(record) {
      jumpSoucePage(record.voucherSn, record.voucherId)
    },
    showAccountModal() {
      this.visible = true
      // this.$nextTick(() => {
      //   // this.$refs.AccountListRef.nameOrCode = undefined
      //   this.$refs.AccountListRef.selectedRowKeys = this.formData.accountCodeList
      //   this.$refs.AccountListRef.selectedRows = this.selectedRows
      // })
    },
    clearAccount() {
      this.formData.accountCodeList = []
      this.accountName = undefined
      this.selectedRows = []
      this.searchHandle(1)
    },
    onSelect(list) {
      this.selectedRows = list
    },
    onOk() {
      this.visible = false
      this.formData.accountCodeList = this.selectedRows.map((item) => item.code)
      this.accountName = this.selectedRows.map((item) => item.full_name).join(';')
      this.searchHandle(1)
    },
    goToAccountJournalList(record) {
      const data = {
        accountSetCode: record.accountSetCode,
        businessUnitCode: record.businessUnitCode,
        accountCode: record.accountCode,
        accountName: record.accountName,
        accountingPeriodStart: this.formData.accountingPeriodStart,
        accountingPeriodEnd: this.formData.accountingPeriodEnd,
      }
      localStorage.setItem('accountJournalInfo', JSON.stringify(data))
      this.$router.push({
        name: 'accountJournalList',
      })
    },
  },
}
</script>
